import axios from './api'

export const maintenanceApi = {
  // Get maintenance status (public)
  getStatus: async () => {
    const response = await axios.get('/maintenance/status')
    return response.data
  },

  // Enable maintenance mode (admin only)
  enableMaintenanceMode: async (message = '') => {
    const response = await axios.post('/maintenance/enable', { message })
    return response.data
  },

  // Disable maintenance mode (admin only)
  disableMaintenanceMode: async () => {
    const response = await axios.post('/maintenance/disable')
    return response.data
  },

  // Update maintenance message (admin only)
  updateMaintenanceMessage: async (message) => {
    const response = await axios.put('/maintenance/message', { message })
    return response.data
  },

  // Set scheduled maintenance (admin only)
  setScheduledMaintenance: async (maintenanceData) => {
    const response = await axios.post('/maintenance/scheduled', maintenanceData)
    return response.data
  }
}

export default maintenanceApi
